export default __webpack_public_path__ + "static/media/sendIcon-bold.a60f635f.svg";